import Settings from '@engine/features/dashboard/chart/dashboard_chart_settings';
import Util from '@engine/features/dashboard/chart/dashboard_chart_utility';
import noUiSlider from 'nouislider';
var WEEK_DAYS = 7;
var DAY_HOURS = 24;
var MINUTE = 60;
var TIMESTAMP_MULTIPLIER = 1000;
var WEEK_STEPS = WEEK_DAYS * DAY_HOURS * MINUTE * MINUTE * TIMESTAMP_MULTIPLIER;
var DAY_STEPS = DAY_HOURS * MINUTE * MINUTE * TIMESTAMP_MULTIPLIER;
var TOOLTIPS_ANIMATION = 200;

function Slider() {
  var dateSlider = null;

  function options() {
    return {
      range: {
        min: Util.startTimestamp(Settings.DATA_PERIOD),
        max: Util.timestamp()
      },
      start: [Util.startTimestamp(Settings.DEFAULT_DATE_RANGE), Util.timestamp()],
      pips: {
        mode: 'positions',
        // eslint-disable-next-line no-magic-numbers
        values: [0, 25, 50, 75, 100],
        format: {
          to: Util.formatLabel
        }
      },
      // Steps of one day
      step: DAY_STEPS,
      margin: WEEK_STEPS,
      connect: true,
      tooltips: true,
      format: {
        to: Util.formatLabel,
        from: function from(value) {
          return value;
        }
      }
    };
  }

  function create(element) {
    noUiSlider.create(element, options());
    element.noUiSlider.on('start', function () {
      $('.noUi-tooltip').fadeIn(TOOLTIPS_ANIMATION);
    });
    element.noUiSlider.on('end', function () {
      $('.noUi-tooltip').fadeOut(TOOLTIPS_ANIMATION);
    });
    dateSlider = element;
  }

  function onUpdate(callback) {
    dateSlider.noUiSlider.on('slide', callback);
    dateSlider.noUiSlider.on('set', callback);
  }

  function emitUpdateEvent() {
    dateSlider.noUiSlider.updateOptions(options());
  }

  return {
    options: options,
    create: create,
    onUpdate: onUpdate,
    emitUpdateEvent: emitUpdateEvent
  };
}

export default Slider();